import { useEffect, useState } from "react";

import { Listbox, Transition } from "@headlessui/react";
import PropTypes from "prop-types";

import { formatDate } from "common/functions";

import ButtonNew from "components/atoms/ButtonNew/index";
import { FaSearch } from "components/atoms/Icon/fa/FaSearch";
import { FiCalendar } from "components/atoms/Icon/fi/FiCalendar";
import { FiChevronDown } from "components/atoms/Icon/fi/FiChevronDown";
import { FiFilter } from "components/atoms/Icon/fi/FiFilter";
import Img from "components/atoms/Img";
import Link from "components/atoms/LinkRouter";
import Title from "components/atoms/Title";
import FormNewsletter from "components/molecules/FormNewsletter";
import PostItem from "components/molecules/PostItem";
import Banner from "components/organisms/Banner";

const Articles = ({ data, posts }) => {
  const [country, setCountry] = useState(
    data?.dropdownData ? data?.dropdownData?.data[0] : { value: "all" }
  );
  const [keyWord, setkeyWord] = useState();
  const [filter, setFilter] = useState(false);
  const [results, setResults] = useState([]);
  const [perPage, setPerPage] = useState(9);
  const [isLoading, setIsLoading] = useState(false);
  const firstPost = posts[0] || null;
  const category = firstPost?.categories?.nodes.filter(
    (item) => item.parent === null
  );
  const listPost =
    posts.length > 1 ? posts.filter((item, index) => index > 0) : [];

  useEffect(() => {
    let result = posts;

    if (keyWord) {
      const keyWordLowerCase = keyWord.toLowerCase().trim();

      result = result.filter(
        (item) =>
          item?.title.toLowerCase().trim().includes(keyWordLowerCase) ||
          item?.excerpt
            .replace(/<[^>]+>/g, "")
            .toLowerCase()
            .trim()
            .includes(keyWordLowerCase)
      );
    }
    if (country.value !== "all") {
      setFilter(true);
      if (data?.dropdownData?.type === "categories") {
        result = result.filter((item) =>
          item.categories.nodes.find((node) => node.name === country.value)
        );
      } else {
        result = result.filter((item) =>
          item.tags.nodes.find((node) => node.name === country.value)
        );
      }
    }
    if (!keyWord && country.value === "all") {
      setFilter(false);
      result = [];
    }
    setResults(result);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [keyWord, country]);

  const handleSearch = (keyWord) => {
    const keyWordLowerCase = keyWord.toLowerCase().trim();

    setkeyWord(keyWordLowerCase);
  };

  const handleLoadMore = () => {
    setIsLoading(!isLoading);
    setTimeout(() => {
      const currentPerPage = perPage + 6;

      setPerPage(currentPerPage);
      setIsLoading(false);
    }, 500);
  };

  return (
    <>
      <section>
        <Banner
          minHeightBanner="banner-min-h-569"
          title={data?.banner?.title}
          // Author="Content team"
          breadcrumbs={data?.banner?.breadcrumbs}
          description={data?.banner?.description}
          bgColor="bg-bbc-gradient-8"
          leftClassName="lg:col-6"
          rightClassName="lg:col-5"
          rightContent={
            <Img
              wrapper={{
                className: "bbc-banner-image-country xl:top-24",
              }}
              alt="banner"
              priority={true}
              {...data?.banner?.image}
            />
          }
        ></Banner>
      </section>
      <section>
        <div className="container">
          <div className="row">
            {data?.searchBar && (
              <div className="col-12 lg:col-8">
                <div className="overflow-hidden rounded-[49px] border border-bbc-neutral-600">
                  <div className="row">
                    <div className="col">
                      <input
                        type="text"
                        placeholder="Enter your keyword"
                        onChange={(e) => handleSearch(e.target.value)}
                        className="form-input h-10 w-full border-0 bg-transparent px-4 tracking-[0.25px] text-[rgba(51,51,51,0.5)] focus:ring-0"
                      />
                    </div>
                    <div className="col-auto flex items-center justify-center">
                      <div className="px-4">
                        <FaSearch className="text-bbc-neutral-600" size={18} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            {data?.dropdownData?.data && (
              <div className="col-12 mt-6 lg:col-4 lg:mt-0">
                <Listbox
                  as="div"
                  value={country}
                  onChange={(value) => {
                    setCountry(value);
                  }}
                  className="relative w-full rounded-full border border-bbc-neutral-600"
                  style={{ height: "42px" }}
                >
                  {({ open }) => (
                    <>
                      <Listbox.Button
                        as="div"
                        role="button"
                        className="relative h-full w-full  select-none pl-4 pr-9 text-left focus:outline-0"
                      >
                        <div className="flex h-full items-center gap-x-2">
                          <FiFilter
                            className="text-bbc-neutral-600"
                            size={20}
                          />
                          {country?.icon && (
                            <Img
                              src={`/assets/flags/1x1/${country.icon}.svg`}
                              width={24}
                              height={24}
                              className="rounded-full"
                              style={{ minHeight: "24px", minWidth: "24px" }}
                              alt={country.icon}
                            />
                          )}
                          <span
                            className="tracking-[0.25px truncate"
                            style={{ color: "#33333380" }}
                          >
                            {country.label}
                          </span>
                          <FiChevronDown
                            className={`absolute right-4 top-1/2 float-right -translate-y-1/2 transform align-middle text-bbc-neutral-600  ${
                              open ? "rotate-180" : "rotate-0"
                            } transition-all duration-200`}
                            size={24}
                          />
                        </div>
                      </Listbox.Button>
                      <Transition
                        show={open}
                        leave="transition-all duration-200 ease-out"
                        leaveFrom="opacity-50"
                        leaveTo="opacity-0"
                        className="absolute z-10 mt-2 w-full"
                      >
                        <div className="overflow-hidden rounded-xl shadow-md">
                          <Listbox.Options className="max-h-60 overflow-auto bg-white focus:outline-none">
                            {data?.dropdownData?.data.map((item, itemIdx) => (
                              <Listbox.Option
                                key={itemIdx}
                                className="list-none"
                                value={item}
                              >
                                <div
                                  className={`flex cursor-pointer items-center gap-x-3 px-4 py-3 font-medium ${
                                    country.label === item.label
                                      ? "bg-bbc-primary text-white"
                                      : "hover:bg-bbc-primary hover:bg-opacity-40"
                                  }`}
                                  // OnClick={() => setCountry(item)}
                                >
                                  {item?.icon && (
                                    <Img
                                      src={`/assets/flags/1x1/${item.icon}.svg`}
                                      width={24}
                                      height={24}
                                      style={{
                                        minHeight: "24px",
                                        minWidth: "24px",
                                      }}
                                      className="rounded-full"
                                      alt={item.icon}
                                    />
                                  )}
                                  <span className="truncate">{item.label}</span>
                                </div>
                              </Listbox.Option>
                            ))}
                          </Listbox.Options>
                        </div>
                      </Transition>
                    </>
                  )}
                </Listbox>
              </div>
            )}
          </div>
          {!keyWord && !filter ? (
            <div className="mt-10">
              <div>
                {!keyWord && firstPost ? (
                  <div className="overflow-hidden rounded-3xl bg-white transition-shadow duration-150 hover:shadow-[0px_0px_20px_rgba(124,120,120,0.2)]">
                    <div className="flex flex-col lg:flex-row">
                      <div className="pr-0 lg:col-8 lg:pr-[15px]">
                        <Img
                          alt=""
                          image={firstPost?.featuredImage?.node}
                          wrapper={{ className: "w-full relative" }}
                          className="aspect-[16/9] h-full w-full object-cover"
                        />
                      </div>
                      <div className="col-12 flex flex-col justify-center px-[15px] py-4 lg:col-4">
                        <Title
                          as="h3"
                          className="text-lg  font-semibold text-bbc-brand-800 line-clamp-2 lg:text-2xl lg:leading-9 lg:line-clamp-3"
                        >
                          <Link href={firstPost?.uri}>{firstPost?.title}</Link>
                        </Title>
                        <div
                          className="mt-4 line-clamp-3 lg:mt-6"
                          dangerouslySetInnerHTML={{
                            __html: firstPost.excerpt,
                          }}
                        />
                        <div className="flex flex-wrap justify-between">
                          <div className="mt-6 inline-flex items-center rounded-md bg-bbc-brand-800 px-2 py-0.5">
                            <Img
                              src={`/assets/icons/${category[0].name.toLowerCase()}.svg`}
                              alt="icon"
                              width={16}
                              height={16}
                            />
                            <span className="inline-block pl-[5px] text-sm font-medium text-white">
                              {category.length > 0 && category[0].name}
                            </span>
                          </div>
                          <div className="mt-6 inline-flex items-center">
                            <FiCalendar size={18} />
                            <span className="inline-block pl-2 text-sm">
                              {formatDate(firstPost?.date)}
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          ) : (
            <></>
          )}
          {!keyWord && !filter && listPost.length > 0 ? (
            <>
              <div className="row mt-10 gap-y-10 lg:mt-20 lg:gap-y-20">
                {listPost.map((item, index) => (
                  <div
                    className={`col-12 lg:col-4 ${
                      index < perPage ? "" : "hidden"
                    }`}
                    key={index}
                  >
                    <PostItem post={item} />
                  </div>
                ))}
              </div>
              {perPage < listPost.length ? (
                <div className="mt-10 text-center">
                  <ButtonNew
                    othersClass={`${isLoading ? "cursor-not-allowed" : ""}`}
                    onClick={handleLoadMore}
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <div className="flex items-center">
                        <svg
                          className="text-primary mr-2 h-5 w-5 animate-spin group-hover:text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth={4}
                          />
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          />
                        </svg>
                        Loading...
                      </div>
                    ) : (
                      <>Load more</>
                    )}
                  </ButtonNew>
                </div>
              ) : (
                <></>
              )}
            </>
          ) : (
            <></>
          )}
          {results.length > 0 ? (
            <div className="row -mx-4 mt-8 gap-y-8">
              {results.map((item, index) => (
                <div className="col-12 px-4 lg:col-4" key={index}>
                  <PostItem post={item} />
                </div>
              ))}
            </div>
          ) : (
            <></>
          )}
          {((keyWord || filter) && !(results.length > 0)) ||
          !posts ||
          !(posts.length > 0) ? (
            <div className="border-primary text-primary mt-8 border-l-4 bg-[#fff5e3] py-4 px-6 text-center">
              No results
            </div>
          ) : (
            <></>
          )}
        </div>
      </section>
      <FormNewsletter />
    </>
  );
};

export default Articles;

Articles.propTypes = {
  data: PropTypes.object,
  posts: PropTypes.array,
};

Articles.defaultProps = {
  data: {},
  posts: [],
};
